import { SnLonLat } from '@lib/geo/helpers';

import { IGoogleMapOptions } from '../map';
import { toGoogleMapLatLng } from './google-map-lat-lng';
import { toGoogleMapTypeId } from './google-map-type-id';

export function toGoogleMapOptions(options: IGoogleMapOptions): google.maps.MapOptions {
  const googleOptions: google.maps.MapOptions = {};

  // Handle case where options is undefined or null
  if (!options) {
    return googleOptions;
  }

  Object.keys(options).forEach((key) => {
    const value = options[key];

    switch (key) {
      case 'center':
        const center = SnLonLat.convert(options.center);
        googleOptions.center = toGoogleMapLatLng(center);
        break;

      case 'style':
        if (!options.mapId) {
          googleOptions.mapTypeId = toGoogleMapTypeId(value);
        }
        break;

      default:
        googleOptions[key] = value;
    }
  });

  return googleOptions;
}
